import { Avatar, Button } from "@chakra-ui/react"
import { withPrefix } from "gatsby"
import React from "react"
import { useTranslation } from "react-i18next"
import { useVNZAuthenticationState } from "../hooks/useVNZAuthenticationState"

interface Props {}

const VNZLogoutButton: React.FC<Props> = () => {
  const { logout } = useVNZAuthenticationState()
  const { t } = useTranslation()

  return (
    <Button
      className="logout-from-vnz-button"
      variant="ghost"
      _hover={{
        backgroundColor: "transparent",
      }}
      onClick={logout}
    >
      <Avatar
        size="sm"
        mr={2}
        src={withPrefix(
          "/images/cloud-providers/vnz/img-verizon-cloud-account_64x64.jpg"
        )}
      />
      {t(
        "components.cloudProvider.vnz.authentication.VNZLogoutButton.SwitchAccount"
      )}
    </Button>
  )
}

export default VNZLogoutButton
